<template>
  <span>{{ client.lastName }}, {{ client.firstName }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client } from '@/type';

export default defineComponent({
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
});
</script>
